import { useObservable } from 'react-use-observable';

import eduzzAccountsService from 'v2/services/eduzzAccount';

export default function useGetFingerprint() {
  const [fingerprint] = useObservable(() => eduzzAccountsService.getFingerprint(), []);

  return fingerprint;
}
